const horizontalFieldOfView = 58;
const horizontalResolution = 480;

export const horizonLineTargetPixel = (
    vehicleLength: number,
    installationHeight: number,
    desiredVisibleHeight = 3,
): number => {
    const angle: number = Math.atan((desiredVisibleHeight - installationHeight) / vehicleLength);
    return (
        (horizontalResolution / 2) *
        (1 - Math.tan(horizontalFieldOfView / 2 - angle) / Math.tan(horizontalFieldOfView / 2))
    );
};

export const objectOnFloorTargetPixel = (
    vehicleLength: number,
    installationHeight: number,
    desiredVisibleHeight = 3,
): number => {
    const angle1: number = Math.atan((desiredVisibleHeight - installationHeight) / vehicleLength);
    const angle2: number = Math.atan(installationHeight / vehicleLength);
    const angle: number = angle1 + angle2;
    return (
        (horizontalResolution / 2) *
        (1 - Math.tan(horizontalFieldOfView / 2 - angle) / Math.tan(horizontalFieldOfView / 2))
    );
};
